import VideoBackground from 'components/video-background'
import { NEIGHBARS_ASSETS } from '../constants'

const CtaVideoSection = () => {
  return (
    <section className="neighbars__cta-video">
      <VideoBackground
        className="neighbars__cta-video-media"
        src={`${NEIGHBARS_ASSETS}/Hero MyHNK Mobile.mp4`}
        poster={`${NEIGHBARS_ASSETS}/home-head-mobile.png`}
        desktopSrc={`${NEIGHBARS_ASSETS}/Hero MyHNK Vid.mp4`}
        desktopMinWidth={768}
      />
    </section>
  )
}

export default CtaVideoSection
